import { SVGAttributes } from "react";

export const PullquoteIcon = (
  props: SVGAttributes<SVGElement> & { size: "regular" }
) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2a1 1 0 00-1 1v18a1 1 0 102 0V3a1 1 0 00-1-1zm3 9.067v6.066C5 18.164 5.796 19 6.778 19h3.555c.982 0 1.778-.836 1.778-1.867V13.4c0-1.03-.796-1.867-1.778-1.867H6.778v-.466c0-2.888 1.363-4.2 4.444-4.2.491 0 .89-.418.89-.934 0-.515-.399-.933-.89-.933C7.192 5 5 7.11 5 11.067zm8.889 6.066v-6.066C13.889 7.11 16.08 5 20.11 5c.491 0 .889.418.889.933 0 .516-.398.934-.889.934-3.081 0-4.444 1.312-4.444 4.2v.466h3.555c.982 0 1.778.836 1.778 1.867v3.733C21 18.164 20.204 19 19.222 19h-3.555c-.982 0-1.778-.836-1.778-1.867zM6.778 13.4v3.733h3.555V13.4H6.778zm8.889 0v3.733h3.555V13.4h-3.555z"
        fill="currentColor"
      />
    </svg>
  );
};
PullquoteIcon.displayName = "PullquoteIcon";
